import { render, staticRenderFns } from "./FinishOnboardSection.vue?vue&type=template&id=5de3734a&scoped=true"
import script from "./FinishOnboardSection.vue?vue&type=script&lang=js"
export * from "./FinishOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./FinishOnboardSection.vue?vue&type=style&index=0&id=5de3734a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3734a",
  null
  
)

export default component.exports